import React, {useEffect, useState} from 'react';
import {
    TabAnimationSettingsModel,
    TabComponent,
    TabItemDirective,
    TabItemsDirective
} from "@syncfusion/ej2-react-navigations";
import {useUserParentOrganizations} from "../../hooks/Organization/useUserParentOrganizations";
import {SkeletonComponent} from "@syncfusion/ej2-react-notifications";
import UnauthorizedAlert from "../../components/UnauthorizedAlert/UnauthorizedAlert";
import {ApiException, Organization} from "../../autogenerate/api.generated.clients";
import OrganizationManager from './OrganizationManager/OrganizationManager';
import PermissionLookup from "./PermissionLookup/PermissionLookup";

function AdministrationLanding() {
    const tabAnimation: TabAnimationSettingsModel = {
        previous: {effect: 'None'},
        next: {effect: 'None'}
    };

    const parentOrganizations = useUserParentOrganizations();
    
    if (parentOrganizations.isLoading) {
        return <SkeletonComponent/>
    }
    if (parentOrganizations.isError && parentOrganizations.error instanceof ApiException && parentOrganizations.error.status == 403) {
        return (<UnauthorizedAlert/>);
    }
    const organizationManagementTab = () => <OrganizationManager organizations={parentOrganizations.data!}/>
    
    const permissionLookupTab =  () => <PermissionLookup />


    return (
        <div className='reports-landing-page-container'>
            <div>
                <TabComponent animation={tabAnimation} className='report-landing-tabs'>
                    <TabItemsDirective>
                        <TabItemDirective headerText='Organization Management' content={organizationManagementTab}/>
                        <TabItemDirective headerText='Permission Lookup' content={permissionLookupTab}/>
                    </TabItemsDirective>
                </TabComponent>
            </div>
        </div>
    );
}

export default AdministrationLanding;